import type { ResultBlockData } from '@/types';
import styles from './ResultBlock.module.css';

export function ResultBlock({ label, text, icon }: ResultBlockData) {
  return (
    <section className={styles.block}>
      <div className={styles.lbl}>
        {icon ? (
          <span className={styles.lblIco} aria-hidden>
            {icon}
          </span>
        ) : null}
        {label}
      </div>
      <div className={styles.txt} dangerouslySetInnerHTML={{ __html: text }} />
    </section>
  );
}
